import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import FooterSimple from '../Footer/FooterSimple';
import PageLoader from '../PageLoader/PageLoader';
import './MsvDetailShell.css';
import '../../styles/msv-detail-shared.css';

const MsvDetailShell = ({
    children,
    loading = false,
    error = null,
    loadingMessage = 'Loading…',
    backLabel = 'Back',
    onBack,
    showFooter = true,
}) => {
    if (loading) {
        return (
            <div className="msv-detail-shell">
                <PageLoader message={loadingMessage} />
            </div>
        );
    }

    if (error) {
        return (
            <div className="msv-detail-shell">
                <div className="msv-detail-page">
                    {onBack && (
                        <button type="button" className="msv-detail-back-btn" onClick={onBack}>
                            <FiChevronLeft aria-hidden />
                            {backLabel}
                        </button>
                    )}
                    <div className="msv-detail-loading">{error}</div>
                </div>
            </div>
        );
    }

    return (
        <div className="msv-detail-shell">
            <div className="msv-detail-page">
                {onBack && (
                    <button type="button" className="msv-detail-back-btn" onClick={onBack}>
                        <FiChevronLeft aria-hidden />
                        {backLabel}
                    </button>
                )}
                {children}
            </div>
            {showFooter && <FooterSimple />}
        </div>
    );
};

export default MsvDetailShell;
